import { UtenteDTO } from "./utenteDTO";
import { SettoreDTO } from "./settoreDTO";
import { StrutturaDTO } from "./strutturaDTO";
import { StrutturaFascicoloDTO } from "./struttura-fascicoloDTO";

export class AutoreDTO {
      utente: UtenteDTO;

      struttura: StrutturaFascicoloDTO;
}
